module.exports = __webpack_public_path__ + "img/served_by_operator.3737a7e4.svg";